

import {
    POST_PROTOTYPING_UPLOAD_IMAGE,
    POST_PROTOTYPING_UPLOAD_IMAGE_SUCCESS,
    POST_PROTOTYPING_UPLOAD_IMAGE_FAILURE
} from './actionType';

// PROTOTYPING ACTION UPLOAD IMAGE
export const postPrototypingUploadImage = (data) => {
    return {
        type: POST_PROTOTYPING_UPLOAD_IMAGE,
        payload: data
    }
}

export const postPrototypingUploadImageSuccess = (data) => {
    return {
        type: POST_PROTOTYPING_UPLOAD_IMAGE_SUCCESS,
        payload: data
    }
}

export const postPrototypingUploadImageFailure = (data) => {
    return {
        type: POST_PROTOTYPING_UPLOAD_IMAGE_FAILURE,
        payload: data
    }
}